import type { ConfigurationObjectExtractionConfig } from '@/common/modules/config-objects';
import { configuredPinia } from '@/setup/pinia';
import { mountVueApplicationToWidgets } from '@/common/modules/widget-mount';
import Widget from '@/widgets/Wizard/Widget.vue';
import i18n from '@/widgets/Wizard/i18n';
import { matchAccountConfigThroughHostname } from './modules/accounts';
import accounts from './accounts';
import { setupDependencyContainer } from './container';

export const widgetParameterConfig: ConfigurationObjectExtractionConfig = {};

export const initWidgets = async () => {
    const widgets = document.querySelectorAll<HTMLElement>('.w3media-booking-wizard-widget');

    if (widgets.length > 0) {
        const pinia = configuredPinia();

        mountVueApplicationToWidgets(
            Widget,
            'Wizard',
            widgets,
            widgetParameterConfig,
            i18n,
            [i18n, pinia],
            {},
            (app, params) => {
                const account = matchAccountConfigThroughHostname(window.location.hostname, accounts);

                if (account) {
                    setupDependencyContainer(app, account);
                }
            },
        );
    }
};

if (!import.meta.env.DEV) {
    initWidgets();
}
